/**
 * LUADA Portal-basiertes Funnel System
 * Zuverlässige Lösung ohne Z-Index-Konflikte für Shopify
 */
(function() {
    'use strict';
    
    // Konfiguration
    const CONFIG = {
        portalId: 'luada-portal-root',
        animationDuration: 300
    };
    
    // Portal-Zustand
    let portalRoot = null;
    let isOpen = false;
    let funnelData = null;
    
    // Funnel HTML Template - Kompletter Konfigurator
    const PORTAL_TEMPLATE = `
        <div class="luada-portal-overlay">
            <div class="luada-portal-container">
                <div class="luada-funnel-header">
                    <h2 class="luada-funnel-title">Ihre LUADA 2 konfigurieren</h2>
                    <button class="luada-funnel-close" aria-label="Schließen" style="position: absolute; top: 16px; right: 16px; background: white; border: 1px solid #e5e7eb; border-radius: 50%; width: 36px; height: 36px; display: flex; align-items: center; justify-content: center; cursor: pointer; box-shadow: 0 2px 8px rgba(0,0,0,0.1); z-index: 1000;">
                        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M18 6L6 18M6 6L18 18" stroke="#DC2626" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                    </button>
                </div>
                <div class="luada-progress-bar">
                    <div class="luada-progress-step active" data-step="1">
                        <div class="luada-progress-circle">1</div>
                        <div class="luada-progress-label">Gehäuse</div>
                    </div>
                    <div class="luada-progress-step" data-step="2">
                        <div class="luada-progress-circle">2</div>
                        <div class="luada-progress-label">Armband</div>
                    </div>
                    <div class="luada-progress-step" data-step="3">
                        <div class="luada-progress-circle">3</div>
                        <div class="luada-progress-label">Abonnement</div>
                    </div>
                    <div class="luada-progress-step" data-step="4">
                        <div class="luada-progress-circle">4</div>
                        <div class="luada-progress-label">Zusammenfassung</div>
                    </div>
                </div>
                <div class="luada-funnel-content">
                    <!-- Step 1: Case Selection -->
                    <div class="luada-funnel-step active" data-step="1">
                        <h3 class="luada-step-title">Wählen Sie die Gehäusefarbe</h3>
                        <div class="luada-case-options">
                            <div class="luada-case-option selected" data-case="schwarz">
                                <div class="luada-checkmark">
                                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" width="20" height="20">
                                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="3" d="M5 13l4 4L19 7"/>
                                    </svg>
                                </div>
                                <img src="https://cdn.shopify.com/s/files/1/0549/4469/4522/files/1_9970be1b-283d-4422-a7d8-470da86ee342.webp?v=1762429190" alt="Schwarzes Gehäuse">
                                <div class="luada-case-name">Schwarzes Gehäuse</div>
                            </div>
                            <div class="luada-case-option" data-case="weiss">
                                <div class="luada-checkmark">
                                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" width="20" height="20">
                                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="3" d="M5 13l4 4L19 7"/>
                                    </svg>
                                </div>
                                <img src="https://cdn.shopify.com/s/files/1/0549/4469/4522/files/2_92e470d6-05f8-474a-8fe2-2a872f3c2c12.webp?v=1762429190" alt="Weißes Gehäuse">
                                <div class="luada-case-name">Weißes Gehäuse</div>
                            </div>
                        </div>
                    </div>
                    
                    <!-- Step 2: Band Selection -->
                    <div class="luada-funnel-step" data-step="2">
                        <h3 class="luada-step-title">Wählen Sie Ihr GRATIS Zusatz-Armband</h3>
                        <div class="luada-band-preview-wrapper">
                            <div class="luada-timer-banner">
                                <div class="luada-timer-title">⏰ Limitierte Aktion!</div>
                                <div class="luada-timer-offer">
                                    <span class="luada-timer-old-price">39,95 €</span>
                                    <span>→</span>
                                    <span class="luada-timer-new-price">0 €</span>
                                </div>
                                <div style="font-weight:700;margin-bottom:.75rem">
                                    <strong>Zusätzliches Stoff-Armband GRATIS!</strong>
                                </div>
                                <div class="luada-timer-countdown" id="timerCountdown">
                                    <div class="luada-timer-unit">
                                        <div class="luada-timer-value" id="timerHours">00</div>
                                        <div class="luada-timer-label">Std</div>
                                    </div>
                                    <div class="luada-timer-unit">
                                        <div class="luada-timer-value" id="timerMinutes">00</div>
                                        <div class="luada-timer-label">Min</div>
                                    </div>
                                    <div class="luada-timer-unit">
                                        <div class="luada-timer-value" id="timerSeconds">00</div>
                                        <div class="luada-timer-label">Sek</div>
                                    </div>
                                </div>
                            </div>
                            <div class="luada-band-selection-container">
                                <div class="luada-band-preview-section">
                                    <img id="bandPreviewImage" class="luada-band-preview-image" src="https://cdn.shopify.com/s/files/1/0549/4469/4522/files/1-1.webp?v=1760010073" alt="Armband Vorschau">
                                </div>
                                <div class="luada-band-options-section">
                                    <div class="luada-funnel-band-grid">
                                <div class="luada-funnel-band-item" data-band="rot" data-image-b="https://cdn.shopify.com/s/files/1/0549/4469/4522/files/1-1.webp?v=1760010073" data-image-w="https://cdn.shopify.com/s/files/1/0549/4469/4522/files/8-1.webp?v=1760010073">
                                    <input type="radio" name="luada-funnel-band-color" value="rot" id="luada-funnel-band-rot" class="luada-funnel-band-input" checked>
                                    <label for="luada-funnel-band-rot" class="luada-funnel-band-button">
                                        <div class="luada-funnel-band-color-preview" style="background: #771529;"></div>
                                        <div class="luada-funnel-band-checkmark">✓</div>
                                    </label>
                                </div>
                                <div class="luada-funnel-band-item" data-band="schwarz" data-image-b="https://cdn.shopify.com/s/files/1/0549/4469/4522/files/6.webp?v=1760010074" data-image-w="https://cdn.shopify.com/s/files/1/0549/4469/4522/files/12-1.webp?v=1760010073">
                                    <input type="radio" name="luada-funnel-band-color" value="schwarz" id="luada-funnel-band-schwarz" class="luada-funnel-band-input">
                                    <label for="luada-funnel-band-schwarz" class="luada-funnel-band-button">
                                        <div class="luada-funnel-band-color-preview" style="background: #000000;"></div>
                                        <div class="luada-funnel-band-checkmark">✓</div>
                                    </label>
                                </div>
                                <div class="luada-funnel-band-item" data-band="weiss" data-image-b="https://cdn.shopify.com/s/files/1/0549/4469/4522/files/2_3bbd5ea1-2afd-42a7-bbcb-2949d1514b68.webp?v=1760010073" data-image-w="https://cdn.shopify.com/s/files/1/0549/4469/4522/files/7.webp?v=1760010075">
                                    <input type="radio" name="luada-funnel-band-color" value="weiss" id="luada-funnel-band-weiss" class="luada-funnel-band-input">
                                    <label for="luada-funnel-band-weiss" class="luada-funnel-band-button">
                                        <div class="luada-funnel-band-color-preview" style="background: #ffffff; border: 2px solid #e5e7eb;"></div>
                                        <div class="luada-funnel-band-checkmark">✓</div>
                                    </label>
                                </div>
                                <div class="luada-funnel-band-item" data-band="lila" data-image-b="https://cdn.shopify.com/s/files/1/0549/4469/4522/files/4.webp?v=1760010074" data-image-w="https://cdn.shopify.com/s/files/1/0549/4469/4522/files/10.webp?v=1760010074">
                                    <input type="radio" name="luada-funnel-band-color" value="lila" id="luada-funnel-band-lila" class="luada-funnel-band-input">
                                    <label for="luada-funnel-band-lila" class="luada-funnel-band-button">
                                        <div class="luada-funnel-band-color-preview" style="background: #B48FCE;"></div>
                                        <div class="luada-funnel-band-checkmark">✓</div>
                                    </label>
                                </div>
                                <div class="luada-funnel-band-item" data-band="gruen" data-image-b="https://cdn.shopify.com/s/files/1/0549/4469/4522/files/3_92d3e56d-3f64-4b8a-9fec-1cf49f34e3c3.webp?v=1760010073" data-image-w="https://cdn.shopify.com/s/files/1/0549/4469/4522/files/9.webp?v=1760010074">
                                    <input type="radio" name="luada-funnel-band-color" value="gruen" id="luada-funnel-band-gruen" class="luada-funnel-band-input">
                                    <label for="luada-funnel-band-gruen" class="luada-funnel-band-button">
                                        <div class="luada-funnel-band-color-preview" style="background: #9CD2C0;"></div>
                                        <div class="luada-funnel-band-checkmark">✓</div>
                                    </label>
                                </div>
                                <div class="luada-funnel-band-item" data-band="rosa" data-image-b="https://cdn.shopify.com/s/files/1/0549/4469/4522/files/5.webp?v=1760010075" data-image-w="https://cdn.shopify.com/s/files/1/0549/4469/4522/files/11-1.webp?v=1760010073">
                                    <input type="radio" name="luada-funnel-band-color" value="rosa" id="luada-funnel-band-rosa" class="luada-funnel-band-input">
                                    <label for="luada-funnel-band-rosa" class="luada-funnel-band-button">
                                        <div class="luada-funnel-band-color-preview" style="background: #EF6E71;"></div>
                                        <div class="luada-funnel-band-checkmark">✓</div>
                                    </label>
                                </div>
                            </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    
                    <!-- Step 3: Subscription -->
                    <div class="luada-funnel-step" data-step="3">
                        <h3 class="luada-step-title">Wählen Sie Ihr Abonnement</h3>
                        <div id="subscriptionContent"></div>
                        <div class="luada-warning-box" id="noSubscriptionWarning">
                            <div class="luada-warning-title">
                                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"/>
                                </svg>
                                Wichtiger Hinweis
                            </div>
                            <div class="luada-warning-content">
                                <p><strong>Ohne Abo:</strong> Uhr ohne Voreinrichtung • Eigene SIM-Karte erforderlich • <a href="https://help.luada.de/hc/de/articles/31916815581585-Kann-ich-eine-beliebige-SIM-Karte-f%C3%BCr-die-LUADA-2-verwenden" target="_blank" rel="noopener noreferrer" class="luada-warning-link">SIM-Details</a></p>
                            </div>
                        </div>
                    </div>
                    
                    <!-- Step 4: Summary -->
                    <div class="luada-funnel-step" data-step="4">
                        <h3 class="luada-step-title">Ihre Bestellung im Überblick</h3>
                        <div class="luada-summary-container">
                            <div class="luada-summary-section">
                                <div class="luada-summary-gift-badge">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8v13m0-13V6a2 2 0 112 2h-2zm0 0V5.5A2.5 2.5 0 109.5 8H12zm-7 4h14M5 12a2 2 0 110-4h14a2 2 0 110 4M5 12v7a2 2 0 002 2h10a2 2 0 002-2v-7"/>
                                    </svg>
                                    <div class="luada-gift-text">
                                        <div class="luada-gift-title">GRATIS Zusatz-Armband</div>
                                        <div class="luada-gift-timer" id="summaryTimer">00:00:00</div>
                                    </div>
                                </div>
                                <div class="luada-summary-image-container">
                                    <img id="summaryProductImage" class="luada-summary-product-image" src="" alt="LUADA 2 Konfiguration">
                                </div>
                                <div class="luada-summary-content">
                                    <div class="luada-summary-item luada-summary-abo-item">
                                    <div class="luada-summary-abo-content-centered">
                                        <span class="luada-summary-value" id="summarySubscription">-</span>
                                        <div class="luada-summary-trial-badge">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"/>
                                            </svg>
                                            30 Tage risikofrei testen
                                        </div>
                                    </div>
                                </div>
                                </div>
                            </div>
                            <div class="luada-summary-total">
                                <h3>Gesamtpreis</h3>
                                <div id="totalOldPrice" style="display:none;text-decoration:line-through;color:#9ca3af;font-size:1.2rem;margin-bottom:.25rem"></div>
                                <div class="luada-total-price" id="totalPrice">199,95 €</div>
                                <div id="totalSavings" style="display:none;color:#16a34a;font-weight:700;font-size:1rem;margin-top:.25rem"></div>
                                <div class="luada-total-subtitle" id="totalSubtitle">einmalig</div>
                                <div class="luada-highlight-bar">
                                    <div class="luada-highlight">
                                        <svg width="20" height="20" viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg" fill="currentColor">
                                            <path d="M42,6H18c-2.2,0-4,1.8-4,4v4C7.4,14,2,19.4,2,26v12h4c0,3.314,2.686,6,6,6s6-2.686,6-6h8c0,3.314,2.686,6,6,6s6-2.686,6-6 h4c2.2,0,4-1.8,4-4V10C46,7.8,44.2,6,42,6z"/>
                                        </svg>
                                        GRATIS Versand
                                    </div>
                                    <div class="luada-highlight">
                                        <svg width="20" height="20" viewBox="0 0 64 64" xmlns="http://www.w3.org/2000/svg" stroke-width="5.2" stroke="currentColor" fill="none">
                                            <path d="M54.89,26.73A23.52,23.52,0,0,1,15.6,49" stroke-linecap="round"/>
                                            <path d="M9,37.17a23.75,23.75,0,0,1-.53-5A23.51,23.51,0,0,1,48.3,15.2" stroke-linecap="round"/>
                                            <polyline points="37.73 16.24 48.62 15.44 47.77 5.24" stroke-linecap="round"/>
                                            <polyline points="25.91 47.76 15.03 48.56 15.88 58.76" stroke-linecap="round"/>
                                        </svg>
                                        30-Tage-Geld-zurück
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="luada-funnel-navigation">
                    <button class="luada-nav-button luada-back-button" id="backBtn" disabled>Zurück</button>
                    <button class="luada-nav-button luada-next-button" id="nextBtn" disabled>Weiter</button>
                </div>
            </div>
        </div>
    `;
    
    
    // Portal-System initialisieren
    class PortalFunnel {
        constructor() {
            this.init();
        }
        
        init() {
            this.createPortalRoot();
            this.bindEvents();
            this.setupViewportHandler();
        }
        
        createPortalRoot() {
            if (portalRoot) return;
            
            // Portal Root direkt an document.body anhängen
            portalRoot = document.createElement('div');
            portalRoot.id = CONFIG.portalId;
            portalRoot.className = 'luada-portal-root';
            portalRoot.innerHTML = PORTAL_TEMPLATE;
            
            // An das Ende des Body anhängen (höchste Priorität)
            document.body.appendChild(portalRoot);
            
            this.bindPortalEvents();
        }
        
        bindPortalEvents() {
            const overlay = portalRoot.querySelector('.luada-portal-overlay');
            const closeBtn = portalRoot.querySelector('.luada-funnel-close');
            
            // Close Button
            closeBtn.addEventListener('click', () => this.close());
            
            // Overlay Click
            overlay.addEventListener('click', (e) => {
                if (e.target === overlay) this.close();
            });
            
            // ESC Key
            document.addEventListener('keydown', (e) => {
                if (e.key === 'Escape' && isOpen) this.close();
            });
        }
        
        setupViewportHandler() {
            // Funktion zur Berechnung der realen Viewport-Höhe
            const setViewportHeight = () => {
                const vh = window.innerHeight * 0.01;
                document.documentElement.style.setProperty('--vh', `${vh}px`);
            };
            
            // Initiale Berechnung
            setViewportHeight();
            
            // Event Listener für Viewport-Änderungen
            window.addEventListener('resize', setViewportHeight);
            window.addEventListener('orientationchange', () => {
                // Verzögerung für Orientierungswechsel
                setTimeout(setViewportHeight, 100);
            });
            
            // Für mobile Browser: Listen auf Visual Viewport API falls verfügbar
            if (window.visualViewport) {
                window.visualViewport.addEventListener('resize', setViewportHeight);
            }
            
            // Fallback für ältere mobile Browser
            let lastHeight = window.innerHeight;
            window.addEventListener('scroll', () => {
                if (window.innerHeight !== lastHeight) {
                    lastHeight = window.innerHeight;
                    setViewportHeight();
                }
            });
        }
        
        bindEvents() {
            // Button Event Listener
            const openBtn = document.getElementById('openFunnelBtn');
            if (openBtn) {
                openBtn.addEventListener('click', () => this.open());
            }
            
            // Page Unload Cleanup
            window.addEventListener('beforeunload', () => this.cleanup());
        }
        
        open() {
            if (isOpen) return;
            
            // Funnel-Zustand vor dem Öffnen zurücksetzen
            this.resetFunnelState();
            
            const overlay = portalRoot.querySelector('.luada-portal-overlay');
            
            // Body Scroll verhindern - mobile-optimiert
            document.body.style.overflow = 'hidden';
            document.body.classList.add('luada-modal-open');
            
            // Viewport-Höhe sofort aktualisieren beim Öffnen
            const setViewportHeight = () => {
                const vh = window.innerHeight * 0.01;
                document.documentElement.style.setProperty('--vh', `${vh}px`);
            };
            setViewportHeight();
            
            // Zusätzliche Überwachung während Modal offen ist
            this.startViewportMonitoring();
            
            // Shopify page-overlay verstecken (falls vorhanden)
            this.hidePageOverlay();
            
            // Trusted Shops Widget verstecken
            this.hideTrustedShops();
            
            // Portal aktivieren
            portalRoot.classList.add('active'); // Z-Index für Portal-Root aktivieren
            overlay.classList.add('active');
            isOpen = true;
            
            // Funnel Content laden
            this.loadFunnelContent();
            
            // Analytics Event
            this.trackEvent('funnel_opened');
        }
        
        close() {
            if (!isOpen) return;
            
            const overlay = portalRoot.querySelector('.luada-portal-overlay');
            
            // Animation starten
            portalRoot.classList.remove('active'); // Z-Index für Portal-Root deaktivieren
            overlay.classList.remove('active');
            isOpen = false;
            
            // Viewport-Monitoring beenden
            this.stopViewportMonitoring();
            
            // Body Scroll wieder aktivieren - mobile-optimiert
            document.body.style.overflow = 'auto';
            document.body.classList.remove('luada-modal-open');
            
            // Shopify page-overlay wieder freigeben
            this.showPageOverlay();
            
            // Trusted Shops Widget wieder anzeigen
            this.showTrustedShops();
            
            // Funnel-Zustand komplett zurücksetzen
            this.resetFunnelState();
            
            // Analytics Event
            this.trackEvent('funnel_closed');
        }
        
        resetFunnelState() {
            // Funnel Zustand komplett zurücksetzen
            this.funnelState = {
                currentStep: 1,
                selectedCase: 'schwarz',
                selectedBand: null,
                selectedSubscriptionType: 'sim',
                selectedPeriod: 'monthly'
            };
        }
        
        // Trusted Shops Widget Management
        hideTrustedShops() {
            // Verschiedene mögliche Trusted Shops Container-IDs prüfen
            const trustedShopsSelectors = [
                '#trustbadge-container-98e3dadd90eb493088abdc5597a70810',
                '[id^="trustbadge-container-"]',
                '.trustbadge',
                '#trustbadge',
                '.trusted-shops-badge',
                '#trusted-shops-badge'
            ];
            
            trustedShopsSelectors.forEach(selector => {
                const element = document.querySelector(selector);
                if (element) {
                    element.style.display = 'none';
                    element.setAttribute('data-luada-hidden', 'true');
                }
            });
        }
        
        showTrustedShops() {
            const hiddenElements = document.querySelectorAll('[data-luada-hidden="true"]');
            hiddenElements.forEach(element => {
                element.style.display = '';
                element.removeAttribute('data-luada-hidden');
            });
        }
        
        hidePageOverlay() {
            const pageOverlay = document.querySelector('.page-overlay');
            if (pageOverlay) {
                pageOverlay.setAttribute('data-luada-funnel-active', 'true');
            }
        }
        
        showPageOverlay() {
            const pageOverlay = document.querySelector('.page-overlay');
            if (pageOverlay) {
                pageOverlay.removeAttribute('data-luada-funnel-active');
            }
        }
        
        async loadFunnelContent() {
            // Funnel ist bereits im Template geladen, jetzt Funktionalität initialisieren
            this.initializeFunnelLogic();
        }
        
        initializeFunnelLogic() {
            // Produktdaten für Shopify
            this.productData = {
                images: {
                    schwarz: "https://cdn.shopify.com/s/files/1/0549/4469/4522/files/LUADA-2-Notrufuhr_fuer_Senioren_f8c8b55b-a169-4dab-820c-13658bac9e4b-1.webp",
                    weiss: "https://cdn.shopify.com/s/files/1/0549/4469/4522/files/Zwischenueberschrift_hinzufuegen_1600_x_1600_px_15_e53b8035-c58c-4c38-8910-6abdf4dc87ae.webp"
                },
                variants: {
                    sim: {
                        schwarz: {
                            monthly: { id: "55042432762121", price: 199.95, oldPrice: 279.95, aboPrice: 14.95, saved: 80 },
                            yearly: { id: "55042432827657", price: 343.95, oldPrice: 459.35, saved: 115 }
                        },
                        weiss: {
                            monthly: { id: "55042432827657", price: 199.95, oldPrice: 279.95, aboPrice: 14.95, saved: 80 },
                            yearly: { id: "55042432827657", price: 343.95, oldPrice: 459.35, saved: 115 }
                        }
                    },
                    emergency: {
                        schwarz: {
                            monthly: { id: "56084211400969", price: 199.95, oldPrice: 279.95, aboPrice: 34, saved: 80 },
                            yearly: { id: "56084212285705", price: 547.95, oldPrice: 687.95, saved: 140 }
                        },
                        weiss: {
                            monthly: { id: "56084211466505", price: 199.95, oldPrice: 279.95, aboPrice: 34, saved: 80 },
                            yearly: { id: "56084212351241", price: 547.95, oldPrice: 687.95, saved: 140 }
                        }
                    },
                    none: {
                        schwarz: { id: "55042444001545", price: 199.95 },
                        weiss: { id: "55042444067081", price: 199.95 }
                    }
                },
                // Armband-Produkte (getrennt nach Gehäusefarbe)
                bandVariants: {
                    schwarz: {
                        rot: { id: "55572599308553", price: 39.95 },
                        schwarz: { id: "55572599243017", price: 39.95 },
                        weiss: { id: "55572599406857", price: 39.95 },
                        lila: { id: "55572599374089", price: 39.95 },
                        gruen: { id: "55572599341321", price: 39.95 },
                        rosa: { id: "55572599275785", price: 39.95 }
                    },
                    weiss: {
                        rot: { id: "56192398590217", price: 39.95 },
                        schwarz: { id: "56192398655753", price: 39.95 },
                        weiss: { id: "56192398622985", price: 39.95 },
                        lila: { id: "56192398754057", price: 39.95 },
                        gruen: { id: "56192398721289", price: 39.95 },
                        rosa: { id: "56192398688521", price: 39.95 }
                    }
                },
                // Rabattcodes
                discountCodes: {
                    freeBand: "Gratis_Stretch"
                },
                // Produkt-Bilder für Summary (Uhr mit verschiedenen Armbändern)
                summaryImages: {
                    schwarz: {
                        rot: "https://cdn.shopify.com/s/files/1/0549/4469/4522/files/1-1.webp?v=1760010073",
                        schwarz: "https://cdn.shopify.com/s/files/1/0549/4469/4522/files/6.webp?v=1760010074",
                        weiss: "https://cdn.shopify.com/s/files/1/0549/4469/4522/files/2_3bbd5ea1-2afd-42a7-bbcb-2949d1514b68.webp?v=1760010073",
                        lila: "https://cdn.shopify.com/s/files/1/0549/4469/4522/files/4.webp?v=1760010074",
                        gruen: "https://cdn.shopify.com/s/files/1/0549/4469/4522/files/3_92d3e56d-3f64-4b8a-9fec-1cf49f34e3c3.webp?v=1760010073",
                        rosa: "https://cdn.shopify.com/s/files/1/0549/4469/4522/files/5.webp?v=1760010075"
                    },
                    weiss: {
                        rot: "https://cdn.shopify.com/s/files/1/0549/4469/4522/files/8-1.webp?v=1760010073",
                        schwarz: "https://cdn.shopify.com/s/files/1/0549/4469/4522/files/12-1.webp?v=1760010073",
                        weiss: "https://cdn.shopify.com/s/files/1/0549/4469/4522/files/7.webp?v=1760010075",
                        lila: "https://cdn.shopify.com/s/files/1/0549/4469/4522/files/10.webp?v=1760010074",
                        gruen: "https://cdn.shopify.com/s/files/1/0549/4469/4522/files/9.webp?v=1760010074",
                        rosa: "https://cdn.shopify.com/s/files/1/0549/4469/4522/files/11-1.webp?v=1760010073"
                    }
                }
            };
            
            // Funnel Zustand
            this.funnelState = {
                currentStep: 1,
                selectedCase: 'schwarz',
                selectedBand: null,
                selectedSubscriptionType: 'sim',
                selectedPeriod: 'monthly'
            };
            
            // Event Listeners für Funnel
            this.bindFunnelEvents();
            this.startCountdown();
            
            // Initial Button State setzen
            this.updateInitialButtonState();
        }
        
        updateInitialButtonState() {
            const container = portalRoot;
            const nextBtn = container.querySelector('#nextBtn');
            
            if (this.funnelState.currentStep === 1 && this.funnelState.selectedCase === 'schwarz') {
                if (nextBtn) {
                    nextBtn.disabled = false;
                }
            }
        }
        
        bindFunnelEvents() {
            const container = portalRoot;
            
            // Navigation Buttons
            const backBtn = container.querySelector('#backBtn');
            const nextBtn = container.querySelector('#nextBtn');
            
            if (backBtn) {
                backBtn.addEventListener('click', () => this.updateStep('back'));
            }
            
            if (nextBtn) {
                nextBtn.addEventListener('click', () => {
                    if (this.funnelState.currentStep === 4) {
                        this.checkout();
                    } else {
                        this.updateStep('next');
                    }
                });
            }
            
            // Case Selection
            container.querySelectorAll('.luada-case-option').forEach(option => {
                option.addEventListener('click', () => {
                    container.querySelectorAll('.luada-case-option').forEach(opt => opt.classList.remove('selected'));
                    option.classList.add('selected');
                    this.funnelState.selectedCase = option.dataset.case;
                    nextBtn.disabled = false;
                });
            });
            
            // Band Selection
            container.querySelectorAll('.luada-funnel-band-item').forEach(option => {
                const radio = option.querySelector('.luada-funnel-band-input');
                
                const updateBandImage = () => {
                    const caseColor = this.funnelState.selectedCase || 'schwarz';
                    const imageUrl = caseColor === 'schwarz' ? option.dataset.imageB : option.dataset.imageW;
                    const previewImage = container.querySelector('#bandPreviewImage');
                    if (previewImage && imageUrl) {
                        previewImage.src = imageUrl;
                    }
                };
                
                option.addEventListener('click', () => {
                    radio.checked = true;
                    this.funnelState.selectedBand = option.dataset.band;
                    updateBandImage();
                    nextBtn.disabled = false;
                });
                
                radio.addEventListener('change', () => {
                    if (radio.checked) {
                        this.funnelState.selectedBand = option.dataset.band;
                        updateBandImage();
                        nextBtn.disabled = false;
                    }
                });
            });
        }
        
        updateStep(direction) {
            const container = portalRoot;
            const currentStepEl = container.querySelector(`.luada-funnel-step[data-step="${this.funnelState.currentStep}"]`);
            const progressStepEl = container.querySelector(`.luada-progress-step[data-step="${this.funnelState.currentStep}"]`);
            const backBtn = container.querySelector('#backBtn');
            const nextBtn = container.querySelector('#nextBtn');
            
            currentStepEl.classList.remove('active');
            
            if (direction === 'next') {
                progressStepEl.classList.add('completed');
                progressStepEl.classList.remove('active');
                this.funnelState.currentStep++;
            } else {
                // Beim Zurückgehen: Aktuellen Schritt und alle nachfolgenden als nicht completed markieren
                progressStepEl.classList.remove('completed');
                progressStepEl.classList.remove('active');
                
                // Alle nachfolgenden Schritte als nicht completed markieren
                for (let i = this.funnelState.currentStep + 1; i <= 4; i++) {
                    const futureProgressStep = container.querySelector(`.luada-progress-step[data-step="${i}"]`);
                    if (futureProgressStep) {
                        futureProgressStep.classList.remove('completed');
                        futureProgressStep.classList.remove('active');
                    }
                }
                
                this.funnelState.currentStep--;
            }
            
            const newStepEl = container.querySelector(`.luada-funnel-step[data-step="${this.funnelState.currentStep}"]`);
            const newProgressStepEl = container.querySelector(`.luada-progress-step[data-step="${this.funnelState.currentStep}"]`);
            
            newStepEl.classList.add('active');
            newProgressStepEl.classList.add('active');
            
            // Step-spezifische Logik
            if (this.funnelState.currentStep === 2) {
                this.initializeBandSelection();
            } else if (this.funnelState.currentStep === 3) {
                this.renderSubscriptionOptions();
            } else if (this.funnelState.currentStep === 4) {
                this.renderSummary();
            }
            
            // Button States
            backBtn.disabled = this.funnelState.currentStep === 1;
            
            // Button Text und Style zurücksetzen für alle Schritte außer dem letzten
            if (this.funnelState.currentStep < 4) {
                nextBtn.textContent = 'Weiter';
                nextBtn.classList.remove('luada-order-button-final');
            }
            
            if (this.funnelState.currentStep === 1) {
                // Da schwarzes Modell vorausgewählt ist, sollte der Button aktiviert sein
                nextBtn.disabled = !this.funnelState.selectedCase;
            } else if (this.funnelState.currentStep === 2) {
                nextBtn.disabled = !this.funnelState.selectedBand;
            } else if (this.funnelState.currentStep === 3) {
                // Da SIM-Abo bereits vorausgewählt ist, Button aktivieren
                nextBtn.disabled = false;
            } else if (this.funnelState.currentStep === 4) {
                nextBtn.textContent = 'Jetzt bestellen';
                nextBtn.classList.add('luada-order-button-final');
                nextBtn.disabled = false;
            }
        }
        
        initializeBandSelection() {
            if (!this.funnelState.selectedBand) {
                const container = portalRoot;
                const firstOption = container.querySelector('.luada-funnel-band-item');
                const previewImg = container.querySelector('#bandPreviewImage');
                
                if (firstOption && previewImg) {
                    const caseColor = this.funnelState.selectedCase || 'schwarz';
                    const imageUrl = caseColor === 'schwarz' ? firstOption.dataset.imageB : firstOption.dataset.imageW;
                    previewImg.src = imageUrl;
                    
                    const firstRadio = firstOption.querySelector('.luada-funnel-band-input');
                    if (firstRadio) {
                        firstRadio.checked = true;
                        this.funnelState.selectedBand = firstOption.dataset.band;
                    }
                }
            }
        }
        
        renderSubscriptionOptions() {
            const container = portalRoot.querySelector('#subscriptionContent');
            const nextBtn = portalRoot.querySelector('#nextBtn');
            
            container.innerHTML = `
                <div class="luada-subscription-options">
                    <div class="luada-subscription-option" data-type="none">
                        <div class="luada-subscription-info">
                            <h4>Kein Abonnement</h4>
                            <p>Einmalige Zahlung - Sie benötigen eine eigene SIM-Karte</p>
                        </div>
                        <div class="luada-subscription-price">199,95 €</div>
                    </div>
                    <div class="luada-subscription-option selected" data-type="sim">
                        <div class="luada-discount-badge">💰 80 Euro Rabatt</div>
                        <div class="luada-free-trial-badge">🎉 30 Tage kostenlos</div>
                        <div class="luada-subscription-info">
                            <h4>SIM-Karten Abo</h4>
                            <div class="luada-subscription-features">
                                <p>✅ SIM bereits verbaut</p>
                                <p>✅ Komplett eingerichtet</p>
                                <p>✅ Sofort einsatzbereit</p>
                            </div>
                        </div>
                        <div class="luada-subscription-price" id="simPrice">
                            <div class="luada-price-main">
                                <span class="luada-price-old">279,95 €</span>
                                <span>199,95 €</span>
                            </div>
                        </div>
                    </div>
                    <div class="luada-subscription-option" data-type="emergency">
                        <div class="luada-discount-badge">💰 80 Euro Rabatt</div>
                        <div class="luada-free-trial-badge">🎉 30 Tage kostenlos</div>
                        <div class="luada-subscription-info">
                            <h4>Notrufzentrale Abo</h4>
                            <div class="luada-subscription-features">
                                <p>✅ Inkl. allen SIM-Abo Vorteilen</p>
                                <p>✅ 24/7 Notrufzentrale</p>
                                <p>✅ Geschultes Personal</p>
                            </div>
                        </div>
                        <div class="luada-subscription-price" id="emergencyPrice">
                            <div class="luada-price-main">
                                <span class="luada-price-old">279,95 €</span>
                                <span>199,95 €</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div id="periodToggleContainer" style="display:block;">
                    <div class="luada-period-toggle">
                        <button class="luada-period-button active" data-period="monthly">
                            <div class="luada-period-checkmark">
                                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="3" d="M5 13l4 4L19 7" />
                                </svg>
                            </div>
                            Monatlich
                        </button>
                        <button class="luada-period-button" data-period="yearly">
                            <span class="luada-period-savings-badge">Spare bis zu 140€</span>
                            <div class="luada-period-checkmark">
                                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="3" d="M5 13l4 4L19 7" />
                                </svg>
                            </div>
                            Jährlich
                        </button>
                    </div>
                </div>
            `;
            
            // Event Listeners für Subscription Options
            container.querySelectorAll('.luada-subscription-option').forEach(option => {
                option.addEventListener('click', () => {
                    container.querySelectorAll('.luada-subscription-option').forEach(opt => opt.classList.remove('selected'));
                    option.classList.add('selected');
                    this.funnelState.selectedSubscriptionType = option.dataset.type;
                    
                    const warning = portalRoot.querySelector('#noSubscriptionWarning');
                    const periodToggle = portalRoot.querySelector('#periodToggleContainer');
                    
                    if (this.funnelState.selectedSubscriptionType === 'none') {
                        warning.classList.add('show');
                        periodToggle.style.display = 'none';
                        nextBtn.disabled = false; // Direktes Weitergehen möglich
                    } else {
                        warning.classList.remove('show');
                        periodToggle.style.display = 'block';
                        nextBtn.disabled = false;
                        this.updateSubscriptionPrices();
                    }
                });
            });
            
            // Period Toggle Events
            container.querySelectorAll('.luada-period-button').forEach(btn => {
                btn.addEventListener('click', () => {
                    container.querySelectorAll('.luada-period-button').forEach(b => b.classList.remove('active'));
                    btn.classList.add('active');
                    this.funnelState.selectedPeriod = btn.dataset.period;
                    this.updateSubscriptionPrices();
                });
            });
            
            // Standard-Auswahl initialisieren
            nextBtn.disabled = false;
            this.updateSubscriptionPrices();
        }
        
        updateSubscriptionPrices() {
            const period = this.funnelState.selectedPeriod;
            const simData = this.productData.variants.sim[this.funnelState.selectedCase][period];
            const emergencyData = this.productData.variants.emergency[this.funnelState.selectedCase][period];
            
            const simPriceEl = portalRoot.querySelector('#simPrice');
            const emergencyPriceEl = portalRoot.querySelector('#emergencyPrice');
            
            if (simPriceEl && simData) {
                if (period === 'monthly') {
                    simPriceEl.innerHTML = `
                        <div class="luada-price-main">
                            <span class="luada-price-old">${simData.oldPrice.toFixed(2).replace('.', ',')} €</span>
                            <span>${simData.price.toFixed(2).replace('.', ',')} €</span>
                        </div>
                        <div class="luada-price-breakdown">+ ${simData.aboPrice.toFixed(2).replace('.', ',')} €/Monat</div>
                    `;
                } else {
                    simPriceEl.innerHTML = `
                        <div class="luada-price-main">
                            <span class="luada-price-old">${simData.oldPrice.toFixed(2).replace('.', ',')} €</span>
                            <span>${simData.price.toFixed(2).replace('.', ',')} €</span>
                        </div>
                        <div class="luada-price-breakdown">Uhr + 1. Jahr Abo</div>
                    `;
                }
            }
            
            if (emergencyPriceEl && emergencyData) {
                if (period === 'monthly') {
                    emergencyPriceEl.innerHTML = `
                        <div class="luada-price-main">
                            <span class="luada-price-old">${emergencyData.oldPrice.toFixed(2).replace('.', ',')} €</span>
                            <span>${emergencyData.price.toFixed(2).replace('.', ',')} €</span>
                        </div>
                        <div class="luada-price-breakdown">+ ${emergencyData.aboPrice.toFixed(0)} €/Monat</div>
                    `;
                } else {
                    emergencyPriceEl.innerHTML = `
                        <div class="luada-price-main">
                            <span class="luada-price-old">${emergencyData.oldPrice.toFixed(2).replace('.', ',')} €</span>
                            <span>${emergencyData.price.toFixed(2).replace('.', ',')} €</span>
                        </div>
                        <div class="luada-price-breakdown">Uhr + 1. Jahr Abo</div>
                    `;
                }
            }
        }
        
        renderSummary() {
            // Produktbild basierend auf Gehäuse und Armband setzen
            const productImage = this.productData.summaryImages[this.funnelState.selectedCase][this.funnelState.selectedBand];
            const summaryImageEl = portalRoot.querySelector('#summaryProductImage');
            if (summaryImageEl && productImage) {
                summaryImageEl.src = productImage;
            }
            
            // Timer für Gift Badge aktualisieren
            this.updateSummaryTimer();
            
            let subscriptionText = '';
            let totalPrice = 0;
            let subtitle = '';
            
            if (this.funnelState.selectedSubscriptionType === 'none') {
                subscriptionText = 'Kein Abonnement';
                totalPrice = this.productData.variants.none[this.funnelState.selectedCase].price;
                subtitle = 'einmalig';
                
                const oldPriceWithBand = 279.95 + 39.95;
                portalRoot.querySelector('#totalOldPrice').textContent = `Statt ${oldPriceWithBand.toFixed(2).replace('.', ',')} €`;
                portalRoot.querySelector('#totalOldPrice').style.display = 'block';
                portalRoot.querySelector('#totalSavings').textContent = '✓ Sie sparen 119,95 €';
                portalRoot.querySelector('#totalSavings').style.display = 'block';
            } else {
                const type = this.funnelState.selectedSubscriptionType;
                const period = this.funnelState.selectedPeriod;
                const data = this.productData.variants[type][this.funnelState.selectedCase][period];
                
                totalPrice = data.price;
                const savings = data.saved + 39.95;
                
                if (period === 'monthly') {
                    if (type === 'sim') {
                        subscriptionText = `SIM-Karten Abo (Monatlich - ${data.aboPrice.toFixed(2).replace('.', ',')} €/Monat)`;
                    } else {
                        subscriptionText = `Notrufzentrale Abo (Monatlich - ${data.aboPrice.toFixed(0)} €/Monat)`;
                    }
                    subtitle = `199,95 € für die Uhr + ${data.aboPrice.toFixed(2).replace('.', ',')} € monatliches Abo (30 Tage kostenlos)`;
                } else {
                    if (type === 'sim') {
                        subscriptionText = 'SIM-Karten Abo (Jährlich - Uhr + 1. Jahr)';
                        const yearlyAboPrice = (data.price - 199.95).toFixed(2).replace('.', ',');
                        subtitle = `199,95 € für die Uhr + ${yearlyAboPrice} € für 1. Jahr Abo inklusive (30 Tage kostenlos testen)`;
                    } else {
                        subscriptionText = 'Notrufzentrale Abo (Jährlich - Uhr + 1. Jahr)';
                        const yearlyAboPrice = (data.price - 199.95).toFixed(2).replace('.', ',');
                        subtitle = `199,95 € für die Uhr + ${yearlyAboPrice} € für 1. Jahr Abo inklusive (30 Tage kostenlos testen)`;
                    }
                }
                
                const oldPriceWithBand = data.oldPrice + 39.95;
                portalRoot.querySelector('#totalOldPrice').textContent = `Statt ${oldPriceWithBand.toFixed(2).replace('.', ',')} €`;
                portalRoot.querySelector('#totalOldPrice').style.display = 'block';
                portalRoot.querySelector('#totalSavings').textContent = `✓ Sie sparen ${savings.toFixed(2).replace('.', ',')} €`;
                portalRoot.querySelector('#totalSavings').style.display = 'block';
            }
            
            portalRoot.querySelector('#summarySubscription').textContent = subscriptionText;
            portalRoot.querySelector('#totalPrice').textContent = `${totalPrice.toFixed(2).replace('.', ',')} €`;
            portalRoot.querySelector('#totalSubtitle').textContent = subtitle;
        }
        
        updateSummaryTimer() {
            const updateTimer = () => {
                const diff = new Date().setHours(24, 0, 0, 0) - Date.now();
                const pad = n => String(n).padStart(2, '0');
                
                const hours = pad(Math.floor(diff / 3600000));
                const minutes = pad(Math.floor(diff % 3600000 / 60000));
                const seconds = pad(Math.floor(diff % 60000 / 1000));
                
                const timerEl = portalRoot.querySelector('#summaryTimer');
                if (timerEl) {
                    timerEl.textContent = `${hours}:${minutes}:${seconds}`;
                }
            };
            
            updateTimer();
            // Timer alle Sekunde aktualisieren
            if (!this.summaryTimerInterval) {
                this.summaryTimerInterval = setInterval(updateTimer, 1000);
            }
        }
        
        async checkout() {
            let mainVariantId;
            
            // Haupt-Produkt Varianten ID bestimmen
            if (this.funnelState.selectedSubscriptionType === 'none') {
                mainVariantId = this.productData.variants.none[this.funnelState.selectedCase].id;
            } else {
                const type = this.funnelState.selectedSubscriptionType;
                const period = this.funnelState.selectedPeriod;
                mainVariantId = this.productData.variants[type][this.funnelState.selectedCase][period].id;
            }
            
            // Armband Varianten ID bestimmen (basierend auf Gehäusefarbe und Armbandfarbe)
            const bandVariantId = this.productData.bandVariants[this.funnelState.selectedCase][this.funnelState.selectedBand].id;
            
            try {
                // Clear Cart
                await fetch('/cart/clear.js', { method: 'POST' });
                
                // Haupt-Produkt zum Warenkorb hinzufügen
                await fetch('/cart/add.js', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({
                        id: mainVariantId,
                        quantity: 1
                    })
                });
                
                // Armband zum Warenkorb hinzufügen
                await fetch('/cart/add.js', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({
                        id: bandVariantId,
                        quantity: 1
                    })
                });
                
                // Analytics Event
                this.trackEvent('funnel_purchase_initiated', {
                    case: this.funnelState.selectedCase,
                    band: this.funnelState.selectedBand,
                    subscription: this.funnelState.selectedSubscriptionType,
                    period: this.funnelState.selectedPeriod,
                    mainProduct: mainVariantId,
                    bandProduct: bandVariantId,
                    discountCode: this.productData.discountCodes.freeBand
                });
                
                // Redirect to Checkout mit Rabattcode als URL-Parameter
                const discountCode = this.productData.discountCodes.freeBand;
                window.location.href = `/checkout?discount=${encodeURIComponent(discountCode)}`;
                
            } catch (error) {
                console.error('Fehler beim Checkout:', error);
                console.log('Verwendete Varianten:', {
                    main: mainVariantId,
                    band: bandVariantId,
                    case: this.funnelState.selectedCase,
                    bandColor: this.funnelState.selectedBand
                });
                alert('Es gab einen Fehler beim Hinzufügen zum Warenkorb. Bitte versuchen Sie es erneut.');
            }
        }
        
        startCountdown() {
            const updateCountdown = () => {
                const diff = new Date().setHours(24, 0, 0, 0) - Date.now();
                const pad = n => String(n).padStart(2, '0');
                
                const hoursEl = portalRoot.querySelector('#timerHours');
                const minutesEl = portalRoot.querySelector('#timerMinutes');
                const secondsEl = portalRoot.querySelector('#timerSeconds');
                
                if (hoursEl) hoursEl.textContent = pad(Math.floor(diff / 3600000));
                if (minutesEl) minutesEl.textContent = pad(Math.floor(diff % 3600000 / 60000));
                if (secondsEl) secondsEl.textContent = pad(Math.floor(diff % 60000 / 1000));
            };
            
            updateCountdown();
            setInterval(updateCountdown, 1000);
        }
        
        trackEvent(eventName, data = {}) {
            // Google Analytics 4
            if (typeof gtag !== 'undefined') {
                gtag('event', eventName, {
                    event_category: 'luada_portal',
                    event_label: 'funnel_configurator',
                    ...data
                });
            }
            
            // Facebook Pixel
            if (typeof fbq !== 'undefined') {
                fbq('track', 'CustomEvent', { eventName, ...data });
            }
        }
        
        cleanup() {
            // Timer stoppen
            if (this.summaryTimerInterval) {
                clearInterval(this.summaryTimerInterval);
                this.summaryTimerInterval = null;
            }
            
            // Viewport-Monitoring beenden
            this.stopViewportMonitoring();
            
            // Funnel-Zustand zurücksetzen
            this.resetFunnelState();
            
            if (portalRoot && portalRoot.parentNode) {
                document.body.removeChild(portalRoot);
                portalRoot = null;
            }
            isOpen = false;
        }
        
        // Viewport-Monitoring für aktives Modal
        startViewportMonitoring() {
            this.stopViewportMonitoring(); // Eventuelle vorherige Listener entfernen
            
            const updateViewport = () => {
                const vh = window.innerHeight * 0.01;
                document.documentElement.style.setProperty('--vh', `${vh}px`);
            };
            
            // Speichere Referenzen für spätere Entfernung
            this.viewportUpdateHandler = updateViewport;
            this.orientationChangeHandler = () => {
                setTimeout(updateViewport, 150);
            };
            
            // Event Listener hinzufügen
            window.addEventListener('resize', this.viewportUpdateHandler);
            window.addEventListener('orientationchange', this.orientationChangeHandler);
            
            // Visual Viewport API für moderne mobile Browser
            if (window.visualViewport) {
                this.visualViewportHandler = updateViewport;
                window.visualViewport.addEventListener('resize', this.visualViewportHandler);
            }
            
            // Für mobile Browser-UI Änderungen (URL-Leiste ein/aus)
            let lastInnerHeight = window.innerHeight;
            this.scrollCheckHandler = () => {
                if (Math.abs(window.innerHeight - lastInnerHeight) > 50) { // Nur bei signifikanten Änderungen
                    lastInnerHeight = window.innerHeight;
                    updateViewport();
                }
            };
            
            // Nutze requestAnimationFrame für performante Überprüfung
            this.viewportCheckInterval = setInterval(this.scrollCheckHandler, 250);
        }
        
        stopViewportMonitoring() {
            // Event Listener entfernen
            if (this.viewportUpdateHandler) {
                window.removeEventListener('resize', this.viewportUpdateHandler);
                this.viewportUpdateHandler = null;
            }
            
            if (this.orientationChangeHandler) {
                window.removeEventListener('orientationchange', this.orientationChangeHandler);
                this.orientationChangeHandler = null;
            }
            
            if (this.visualViewportHandler && window.visualViewport) {
                window.visualViewport.removeEventListener('resize', this.visualViewportHandler);
                this.visualViewportHandler = null;
            }
            
            if (this.viewportCheckInterval) {
                clearInterval(this.viewportCheckInterval);
                this.viewportCheckInterval = null;
            }
        }
    }
    
    // Auto-Initialisierung
    function autoInit() {
        if (document.readyState === 'loading') {
            document.addEventListener('DOMContentLoaded', () => {
                new PortalFunnel();
            });
        } else {
            new PortalFunnel();
        }
    }
    
    // Global API für externe Kontrolle
    window.LuadaPortalFunnel = {
        open: () => {
            if (window.portalInstance) {
                window.portalInstance.open();
            }
        },
        close: () => {
            if (window.portalInstance) {
                window.portalInstance.close();
            }
        }
    };
    
    // Starten
    autoInit();
    
})();